<template>
<!-- 角色管理 -->
<section class="viewContainer">
  <!--工具条-->
  <div v-show="isBanner">
    <div class="main_container">
      <div class="fuji" @click="show3 = !show3">
        <div class="goodslist1">
          <span style="margin-left:20px;margin-top:5px">搜索/查询</span>
          <span class="divReset" @click.stop="fnReset"><img src="../../assets/img/Reset.png" alt /></span>
        </div>
        <div style="position: absolute;right:0;top:-10px" class="sanjiao"></div>
      </div>
      <!-- 顶部搜索框 -->
      <el-collapse-transition>
      <div v-show="show3">
        <el-form class="findform">
          <el-form-item label="角色名称：" style="display:flex;width:35%">
            <el-input v-model="jsName" placeholder="请输入关键词" style="width:90%;"/>
          </el-form-item>
          <el-form-item label="是否启用：" style="display:flex;width:35%">
            <el-select v-model="caozuo" placeholder="请选择" style="width:90%">
              <el-option :label="item.label" :value="item.Id" v-for="(item,index) in caozuoarr" :key="index"/>
            </el-select>
          </el-form-item>
          <el-form-item> <el-button type="danger" @click="onSubmit">查询</el-button> </el-form-item>
        </el-form>
      </div>
      </el-collapse-transition>
    </div>
    <div class="main_container">
      <section class="model_section">
        <p class="model_top_title">角色管理</p>
        <el-button type="danger" @click="showAddedit('')" v-if="authority.indexOf('add')>-1" data-btnmark="add"
        style="float: right;margin: 5px 10px 0 0;">+ 新增</el-button>
      </section>
      <div class="table_container">
        <el-table :data="users" stripe border>
          <el-table-column prop="num" label="序号" align="center" width="50">
            <template scope="scope"> <span>{{scope.$index + 1}}</span> </template>
          </el-table-column>
          <el-table-column prop="roleid" label="角色ID" align="center">
            <template scope="scope">{{scope.row.roleid}}</template>
          </el-table-column>
          <el-table-column prop="rolename" label="角色名称" align="center">
            <template scope="scope">{{scope.row.rolename}}</template>
          </el-table-column>
          <el-table-column prop="remark" label="描述" align="center" width="230">
            <template slot-scope="scope">{{scope.row.remark}}</template>
          </el-table-column>
          <el-table-column label="是否启用" align="center">
            <template slot-scope="scope">
              <span :title="scope.row.isenabled==1?'否':'是'">{{scope.row.isenabled==1?'否':'是'}}</span>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="LastEditTime" label="最近登录时间" align="center" width="150">
            <template scope="scope">{{scope.row.LastEditTime}}</template>
          </el-table-column> -->
          <el-table-column prop="operatorname" label="操作人" align="center">
            <template scope="scope">{{scope.row.operatorname}}</template>
          </el-table-column>
          <el-table-column prop="operatetime" label="操作时间" align="center" width="150">
            <template scope="scope">{{scope.row.operatetime}}</template>
          </el-table-column>
          <el-table-column label="操作" width="220" fixed="right" align="center">
            <template slot-scope="scope">
              <span class="handle" @click="showAddedit(scope.row)" v-if="authority.indexOf('edit')>-1" data-btnmark="edit">
                <i class="el-icon-edit-outline"></i> 编辑
              </span>
              <span class="handle" @click="showAuthor(scope.row)" v-if="authority.indexOf('setright')>-1" data-btnmark="setright">
                <i class="fa fa-cog" aria-hidden="true"></i> 权限设置
              </span>
              <span class="handle" @click="cardStatus(scope.row)" v-if="authority.indexOf('enabledordisable')>-1" data-btnmark="enabledordisable">
                <i :class="scope.row.isenabled == 0?'el-icon-circle-close':'el-icon-circle-check'"/>
                {{scope.row.isenabled == 0?"禁用":"启用"}}
              </span>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination layout="prev, pager, next" @current-change="handleCurrentChange"
        :page-size="10" :current-page="pageIndex" :total="total" style="float:right;margin:10px 0;"/>
      </div>
    </div>
  </div>
  <!--新增编辑界面-->
  <div class="add_banner pad_left" v-show="isAdd">
    <el-col :span="24" style>
      <p class="model_top_title">角色管理详情</p>
    </el-col>
    <el-form label-width="100px" ref="editForm">
      <el-form-item label="角色名称：" prop="roleName">
        <el-input v-model="roleName" auto-complete="off" style="width:360px"/>
      </el-form-item>
      <el-form-item label="描　　述：" prop="remark">
        <el-input type="textarea" v-model="remark" class="textarea" rows="3" style="width:50%;"/>
      </el-form-item>
    </el-form>
    <div class="dialog-footer">
      <el-button @click="cancelBan()">取消</el-button>
      <el-button type="danger" @click="showBan()">保存</el-button>
    </div>
  </div>
    
  <!--权限设置界面-->
  <el-col :span="24" style="margin-top:10px" class="main_container pad_left" v-show="isAuthor">
    <section class="model_section">
      <el-col :span="24" style>
        <p class="model_top_title">角色管理权限设置</p>
      </el-col>
    </section>
    <div class="block table_container">
      <div class="top_desc_contianer">
        <div class="table_container role_type">角色名称：{{tempRole.rolename}}</div>
        <div class="table_container role_desc">角色描述：{{tempRole.remark}}</div>
        <div class="table_container role_auth">禁用：{{tempRole.roletype==1?'否':'是'}}</div>
      </div>
      <div class="top_desc_contianer title">
        <div class="table_container role_type">功能模块</div>
        <div class="table_container role_auth">操作权限</div>
      </div>
      <el-tree ref="tree" :data="menudata" show-checkbox node-key="menuid" default-expand-all class="tree_data lineheighttree"
        :expand-on-click-node="false" :props="defaultProps" :default-checked-keys="alreadyChoose">
        <div style="width:100%;height:auto;" class="custom-tree-node" slot-scope="{node,data}">
          <span class="left_tree" style="display:inline-block;">{{ node.label }}</span>
          <span class="right_action">
            <div class="el-checkbox-group">
              <el-checkbox v-for="(item,index) in data.buttons" :key="index" :label="item.menuid"
              @change="(e)=>changeBox(index,data,e)" :checked="item.ischecked==1">{{item.menuname}}</el-checkbox>
            </div>
          </span>
        </div>
      </el-tree>
      <!-- <el-tree ref="tree" :data="menu" show-checkbox default-expand-all
        node-key="id" highlight-current class="tree_data" :props="defaultProps">
        <div style="display:flex;width:100%;" slot-scope="{node,data}">
          <div class="left_node">{{ node.label }}</div>
          <div class="right_node">
          <el-checkbox-group v-model="chooseAction">
            <el-checkbox v-for="(item,index) in data.buttonNode" :key="index" :label="item.id"
            @change="()=>changeBox(index,data)" :checked="item.ischecked==1">{{item.name}}</el-checkbox>
          </el-checkbox-group>
          </div>
        </div>
      </el-tree> -->
    </div>

    <div style="margin: 20px 10px;">
      <!-- <p @click.native="editSubmit">保 存</p> -->
      <el-button @click="cancle()">取消</el-button>
      <el-button type="danger" @click="saveSeting()">保存</el-button>
      <el-button type="danger" @click="reset">重 置</el-button>
    </div>
  </el-col>
</section>
</template>
<script>
import alertTrends from '../../common/alertTrends.js';
import { buttongetlist } from "../../api/newOss";
import { insertrole, getMenus, rolelist, updaterole, setTingAuth, } from "../../api/api";
import { postrolelist, rolechangestatus, roleadd, rolegetinfo, roleedit, menugetvalidlist, rolemenuset } from "../../api/comment";
export default {
  mixins: [alertTrends],
  data() {
    return {
      show3: true,
      isBanner: true, // banner是否显示
      isAdd: false, // 新增页面
      isAuthor: false, // 角色权限设置页面
      defaultProps: {
        children: "childs",
        label: "menuname"
      },
      jsName: "", // 角色名称
      caozuo: -1,
      // 启用状态 -1=全部 0=启用 1=停用
      caozuoarr: [
        {
          Id: -1,
          label: "全部"
        },
        {
          Id: 0,
          label: "启用"
        },
        {
          Id: 1,
          label: "停用"
        }
      ],
      users: [], // 列表
      pageIndex: 1,
      total: 0,
      
      editid: '', // 详情id
      roleName: '', // 角色名称
      remark: '', // 描述

      menudata: [],
      alreadyChoose: [],
      chooseAction: [],
      temproleId: "",
      tempRole: {},
      
      authority: '', // 按钮权限
      
    };
  },
  methods: {
    // 按钮权限
    handlebtn(){
      let obj = {mark: 'role',};
      buttongetlist(obj).then(data => {
        this.authority = data.resultObj;
      })
    },
    init() {
      var loginParams = {
        rolename: this.jsName,
        isenabled: this.caozuo,
        pageindex: this.pageIndex,
        pagesize: 10,
      };
      postrolelist(loginParams).then(data => {
        this.users = data.resultObj.list; // 角色集合
        this.total = data.resultObj.totalcount; // 总记录数
      }).catch(err => {
        this.users = [];
        this.total = 0;
      });
    },
    // 分页
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.init();
    },
    // 启用&禁用
    cardStatus(row){
      this.$swal({
        type: "warning",
        text: row.isenabled == 0 ? "是否执行禁用操作" : "是否执行启用操作",
        showCancelButton: true,
        reverseButtons: true, // 添加这一行来反转按钮顺序
        cancelButtonText: "取消",
        confirmButtonText: "确定"
      }).then(res => {
        if (res.value) {
          // 确定执行操作
          let obj = {
            roleid: row.roleid, // 角色ID
            status: row.isenabled == 0 ? 1 : 0 // 0=启用 1=禁用
          }
          rolechangestatus(obj).then(data=>{
            if(data.resultCode == 1){
              this.init();
              this.showAlert('操作成功', 'success');
            }
          })
        }
      });
    },
    // 重置
    fnReset() {
      this.jsName = '';
      this.caozuo = -1;
      // this.pageIndex = 1;
      // this.init();
    },
    // 查询按钮
    onSubmit() {
      this.pageIndex = 1;
      this.init();
    },
    // 新增
    showAddedit(row) {
      this.isBanner = false;
      this.isAdd = true;
      if(row){ //编辑资料
        this.editid = row.roleid;
        // 回显接口
        rolegetinfo('',row.roleid).then(res => {
          this.editid = res.resultObj.roleid; // 角色ID
          this.roleName = res.resultObj.rolename; // 角色名称
          this.remark = res.resultObj.remark; // 备注
        })
      }else{
        this.editid = '';
        this.roleName = "";
        this.remark = "";
      }
    },
    // 新增&编辑 保存
    showBan() {
      if(this.editid){ var jsid = this.editid; }
      let loginParams = {
        roleid: jsid, // 角色ID
        rolename: this.roleName, // 角色名称
        remark: this.remark, // 备注
      };
      let thisApi = this.editid==''?roleadd:roleedit;
      thisApi(loginParams).then(data => {
        if (data.resultCode == 1) {
          this.isBanner = true;
          this.isAdd = false;
          this.isAuthor = false;
          this.showAlert('保存成功', 'success');
          this.init();
        }
      }).catch(err => {
        this.users = [];
      });
    },
    // 详情页取消
    cancelBan() {
      this.isBanner = true;
      this.isAdd = false;
    },
    // 角色权限设置
    showAuthor(row) {
      console.log("row", row);
      this.temproleId = row.roleid;
      this.tempRole = row;
      this.isBanner = false;
      this.isAdd = false;
      this.isAuthor = true;
      this.menudata = [];
      this.getmenus();
    },
    // 获取菜单列表(标识角色已设置菜单)
    getmenus() {
      let params = {
        menutype: [], // 菜单类型集合 传空数组或者[1,2,3]
        roleid: this.temproleId, // 角色ID
      };
      let tempChoose = [], tempAction = [];
      menugetvalidlist(params).then(r => {
        let that = this;
        that.menudata = r.resultObj;
        // 获取已经选的菜单模块
        for (let obj of that.menudata) {
          if (obj.childs.length == 0) {
            obj.ischecked == 1 ? tempChoose.push(obj.menuid) : "";
          } else {
            for (let sec of obj.childs) {
              sec.ischecked == 1 ? tempChoose.push(sec.menuid) : "";
            }
          }
          if (obj.childs.length > 0) {
            for (let sec of obj.childs) {
              if (sec.buttons.length > 0) {
                for (let third of sec.buttons) {
                  third.ischecked == 1 ? tempAction.push(third.menuid) : "";
                }
              }
            }
          }
          // if (obj.buttons.length > 0) {
          //   for (let sec of obj.buttons) {
          //     sec.ischecked == 1 ? tempAction.push(sec.menuid) : "";
          //   }
          // } else {
          //   if (obj.childs.length > 0) {
          //     for (let sec of obj.childs) {
          //       if (sec.buttons.length > 0) {
          //         for (let third of sec.buttons) {
          //           third.ischecked == 1 ? tempAction.push(third.menuid) : "";
          //         }
          //       }
          //     }
          //   }
          // }
        }
        that.alreadyChoose = tempChoose;
        that.chooseAction = tempAction;
      });
      // setTimeout(v => {
      //   let arr = document.querySelectorAll(".right_action");
      //   arr.forEach(v => {
      //     let prev =v.previousElementSibling;
          
      //     prev.style.height=prev.style.lineHeight=v.offsetHeight+"px";
      //     console.log(v.offsetHeight,prev.style)
      //   });
      // }, 1000);
      var timer = setInterval(()=>{
      
         let arr = document.querySelectorAll(".right_action");
        if(arr.length>1){
           clearInterval(timer)
          let arr = document.querySelectorAll(".right_action");
        arr.forEach(v => {
          let prev =v.previousElementSibling;
          
          prev.style.height=prev.style.lineHeight=v.offsetHeight+"px";
        })
        }
        
      },30)
    },

    // 保存角色
    saveSeting() {
      // console.log(this.$refs.tree.getHalfCheckedKeys());
      // console.log(
      //   this.chooseAction
      //     .concat(this.$refs.tree.getCheckedKeys())
      //     .concat(this.$refs.tree.getHalfCheckedKeys())
      //     .join(",")
      // );
      let params = {
        roleid: this.temproleId,
        menus: this.chooseAction
          .concat(this.$refs.tree.getCheckedKeys())
          .concat(this.$refs.tree.getHalfCheckedKeys()),
      };
      rolemenuset(params).then(r => {
        this.init();
        this.showAlert('设置成功', 'success');
        this.isBanner = true;
        this.isAdd = false;
        this.isAuthor = false;
      });
    },
    // 重置角色
    reset() {
      this.$refs.tree.setCheckedKeys([]);
      this.alreadyChoose = [];
      this.chooseAction = [];
    },
    // 角色详情取消
    cancle() {
      this.isBanner = true;
      this.isAdd = false;
      this.isAuthor = false;
    },
    changeBox(node, data, e) {
      let that = this;
      let id = data.buttons[node].menuid
      let index = that.chooseAction.indexOf(id)
      if(e){
        that.chooseAction.push(id)
      }else{
        that.chooseAction.splice(index, 1)
      }
      // let tempArry = data.buttons;
      // let tempId = tempArry[node].menuid;
      // let firstId = data.menuid;
      // let have = false;
      // for(let first of tempArry){
      //   let tempIndex = that.chooseAction.indexOf(first.menuid);
      //   if(tempIndex>-1){
      //     have = true;
      //   }
      // }
      // console.log(have)
      // if(!have){
      //   let start = this.alreadyChoose.indexOf(firstId);
      //   start>-1?this.alreadyChoose.splice(start,1):'';
      // }else{
      //   let start = this.alreadyChoose.indexOf(firstId);
      //   start==-1? this.alreadyChoose.push(firstId):'';
      // }
      // this.$refs.tree.setCheckedKeys(this.alreadyChoose);
    },
  },
  watch:{
    // 监听勾选项
    // chooseAction:{
    //   handler(next){
    //     console.log(next,"next")
    //   },
    //   deep:true
    // }
  },
  mounted() {
    this.handlebtn(); // 按钮权限
    this.init();
  },
};
</script>
<style scoped>
.el-input__inner {
  background-color: #fff;
  border: 1px solid #f2f2f2;
}
.el-checkbox__inner {
  width: 16px;
  height: 16px;
  position: relative;
  top: 2px;
} /* 表格 */

.ban_tab {
  box-shadow: 0 0 0 0;
  width: 100%;
  margin: 0 auto;
}
/* 主题 */
/* 表格操作 */
.ban_tab .handle {
  float: left;
  color: #b2b2b2;
  width: 40%;
}
/* .ban_tab p img{
  margin-top:10px
} */
.ban_tab p:first-child {
  margin-left: 7%;
}
.role_type {
  width: 310px;
  box-sizing: border-box;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  color: #555;
}
.role_desc {
  flex: 2;
  -ms-flex: 2;
  -webkit-box-flex: 2;
  height: 100%;
  border-right: 1px solid #eee;
  border-left: 1px solid #eee;
  color: #555;
  display: -webkit-box;
  display: -ms-flexbox;
  padding-left: 30px;
  box-sizing: border-box;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  padding-left: 34px;
}
.role_auth {
  flex: 1;
  -ms-flex: 1;
  -webkit-box-flex: 1;
  height: 100%;
  color: #555;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  padding-left: 30px;
  box-sizing: border-box;
}
.top_desc_contianer {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  line-height: 48px;
  border: 1px solid #eee;
  border-bottom: 0;
}
.title {
  font-size: 14px;
  color: #000;
  font-weight: bold;
  background: rgba(180, 191, 207, 0.12);
}
.title .role_auth,
.title .role_type {
  color: #000;
  border-left: 1px solid #eee;
  padding-left: 34px;
}
/* 树操作 */

.el-tree-node__expand-icon {
  color: #0c0c0c;
}
.el-checkbox__input.is-checked + .el-checkbox__label {
  color: #555;
}
.tree_data .el-tree-node__content {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  
  cursor: pointer;
  position: relative;
  border: 1px solid #eeeeee;
}
.right_action>div{
    display: flex;
    flex-wrap: wrap;
  }
.right_action {
 
  left: 370px;
  position: absolute;
  border-left: 1px solid #eeeeee;
  padding-left: 30px;
  top: 0;
  height: auto;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}
.banner .toolbar {
  height: auto;
}

/* 时间  */
/* .toolbar .line {
  margin-left: 20px;
  line-height: 36px;
} */
/* 时间图标 */
/* .toolbar .line img{
  margin-top:8px
} */
.toolbar .el-button {
  background-color: #F56C6C;
  margin-left: 0;
  color: #fff;
  width: 78px;
}
/* 角色描述 */
.role_induc {
  width: 100%;
  margin-left: 20px;
  text-align: left;
}
/* 内容表格 */
.banner_table {
  background-color: #ffffff;
  box-shadow: 0px 1px 10px 0px rgba(14, 5, 10, 0.1);
  margin-top: 20px;
  height: 640px;
  position: relative;
  /* overflow: hidden;
   */
}
/* 标题 */
.banner_table section {
  height: 55px;
  line-height: 55px;
  border-bottom: 1px solid #eee;
}
.banner_table .el-col-22 p {
  width: 86px;
  height: 55px;

  font-size: 14px;
  font-weight: bold;
  color: #2a2a2a;
  margin-left: 22px;
  line-height: 55px;
  border-bottom: 1px solid #F56C6C;
  margin-top: 0;
}
/* 新增按钮 */
.banner_table .el-col-2 p {
  width: 104px;
  height: 36px;
  background-color: #F56C6C;
  line-height: 36px;
  text-align: center;
  color: #fff;
  border-radius: 3px;
  cursor: pointer;
}

/* 新增页面 */
.add_banner {
  background-color: #ffffff;
  box-shadow: 0px 1px 10px 0px rgba(14, 5, 10, 0.1);
  margin-top: 20px;
  height: 460px;
  position: relative;
}
.add_banner .el-col-24 {
  border-bottom: 1px solid #eee;
  margin-bottom: 20px;
}

.add_banner input {
  border: 1px solid #f2f2f2;
  background: #fff !important;
}
</style>



// WEBPACK FOOTER //
// role.vue?b38f9614